import { IRootState } from '../../types/redux/root';

export const getMenuData = (root: IRootState) => root.menu.data;

export const getMenuState = (root: IRootState) => root.menu.state;
